import { QuotationMark } from '@dreamstack/icons'
import type { BlockSpeechBubbleFragment } from '@dreamstack/investors-graphql'
import type { FunctionComponent } from 'react'
import 'twin.macro'

export const BigQuotationMarks: FunctionComponent<React.PropsWithChildren<{
  block: BlockSpeechBubbleFragment
}>> = ({ block }) => {
  const textField = block.text

  return (
    <div tw="flex justify-start">
      <div tw="relative flex">
        <QuotationMark tw="flex-shrink-0 absolute top-px-12 -translate-x-1/2 left-0 h-px-24 width[28px] text-accentroAqua-100 md:(static translate-x-0 h-px-32 w-px-40 mt-px-16 mr-px-8)" />
        <span tw="text-px-20 leading-px-30 font-semibold text-accentroAqua-full md:(text-px-28 leading-px-42) ml:(text-px-40 leading-px-50) relative">
          {textField}&nbsp;
          <QuotationMark tw="absolute -translate-x-1/2 inline flex-shrink-0 h-px-24 width[28px] text-accentroAqua-100 transform rotate-180 md:(static translate-x-0 h-px-32 w-px-40 mb-px-8)" />
        </span>
      </div>
    </div>
  )
}
